import { render, staticRenderFns } from "./AdminRegisterEdit.vue?vue&type=template&id=5a567414&scoped=true&"
import script from "./AdminRegisterEdit.vue?vue&type=script&lang=js&"
export * from "./AdminRegisterEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminRegisterEdit.vue?vue&type=style&index=0&id=5a567414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a567414",
  null
  
)

export default component.exports